import React from 'react';
import { makeStyles } from '@material-ui/core';
import { scissorStates, scissorTypes } from '../../Config/scissorStates'
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export default function ScissorStateComponent(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let status = ""
    let upper = props.scissorStatus.scissorName === scissorTypes.UPPER
    switch (props.scissorStatus.name) {
        case scissorStates.PRODUCTION:
            status = scissorStates.PRODUCTION.toUpperCase()
            break;
        case scissorStates.SCRAP:
            status = scissorStates.SCRAP.toUpperCase()
            break;
        case scissorStates.UNPLANNEDSTOP:
            status = scissorStates.UNPLANNEDSTOP.toUpperCase()

            break;
        case scissorStates.PLANNEDSTOP:
            status = scissorStates.PLANNEDSTOP.toUpperCase()

            break;
        default:
    }

    return (
        <div className={clsx({ [classes.extraSmallContainer]: props.size === 'XS', [classes.smallContainer]: props.size === 'S', [classes.mediumContainer]: props.size === 'M',[classes.largeContainer]: props.size === 'L' })} style={{ borderRadius: props.size === "XS"? "5px" :upper ? "5px 5px 0 0" : "0 0 5px 5px", border: "1px solid #DEDEDE", borderBottom: upper & props.size !== "XS" ? "none" : "1px solid #DEDEDE" }}>
            {props.size !== "XS" ?
                <div className={clsx({ [classes.extraSmallArrow]: props.size === 'XS', [classes.smallArrow]: props.size === 'S',[classes.mediumArrow]: props.size === 'M', [classes.largeArrow]: props.size === 'L' })}>

                    {props.size === "L" || props.size === "M" ?
                        <React.Fragment>
                            <div className={classes.lineNumber}>{props.machineNumber}</div>
                            <div className={classes.arrow}>
                                {upper ?
                                    <img className={classes.largeArrowIcon} alt="scissorUp" src={process.env.PUBLIC_URL + '/img/scissorArrowUp.svg'}></img>
                                    :
                                    <img className={classes.largeArrowIcon} alt="scissorDown" src={process.env.PUBLIC_URL + '/img/scissorArrowDown.svg'}></img>}
                            </div>
                        </React.Fragment> :
                        upper ?
                            <img className={classes.smallArrowIcon} alt="scissorUp" src={process.env.PUBLIC_URL + '/img/scissorArrowUp.svg'}></img>
                            :
                            <img className={classes.smallArrowIcon} alt="scissorDown" src={process.env.PUBLIC_URL + '/img/scissorArrowDown.svg'}></img>
                    }
                </div> : <React.Fragment></React.Fragment>}

            <div className={clsx({ [classes.extraSmallStatus]: props.size === 'XS', [classes.smallStatus]: props.size === 'S', [classes.mediumStatus]: props.size === 'M',[classes.largeStatus]: props.size === 'L' })} style={{ backgroundColor: props.scissorStatus.backgroundColorInHex, color: props.scissorStatus.foregroundColorInHex }}>
                {t(status)}
            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    extraSmallContainer: {
        height: "20px",
        width: "150px",
        marginLeft:"auto",
        marginRight:"auto",
        marginTop:"5px"       
    },
    smallContainer: {
        height: "30px",
    },
    mediumContainer: {
        height: "40px",
        width:"377px",
        float: "right",
        boxSizing: "border-box"
    },
    largeContainer: {
        width: "400px",
        height: "40px",
        float: "right",
        boxSizing: "border-box"
    },
    extraSmallArrow: {
        width: "15%",
        float: "left",
        paddingTop: "8px",
        paddingLeft: "6px",
        boxSizing: "border-box"
    },
    smallArrow: {
        width: "15%",
        float: "left",
        paddingTop: "8px",
        paddingLeft: "6px",
        boxSizing: "border-box"
    },
    mediumArrow: {
        width: "20%",
        paddingRight:"7px",
        float: "left",
        paddingTop: "8px",
        boxSizing: "border-box"
    },
    largeArrow: {
        width: "20%",
        float: "left",
        paddingTop: "8px",
        paddingLeft: "6px",
        boxSizing: "border-box"
    },
    smallArrowIcon: {
        height: "15px"
    },
    largeArrowIcon: {
        height: "25px"
    },
    extraSmallStatus: {
        width:"100%",
        height: "20px",
        float: "left",
        fontSize: "11px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        paddingTop: "4px",
        boxSizing: "border-box"
    },
    smallStatus: {
        width: "85%",
        height: "30px",
        float: "left",
        fontSize: "11px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        paddingTop: "8px",
        boxSizing: "border-box"
    },
    mediumStatus: {
        width: "80%",
        height: "39px",
        float: "left",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        paddingTop: "8px",
        boxSizing: "border-box"
    },
    largeStatus: {
        width: "80%",
        height: "39px",
        float: "left",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        paddingTop: "8px",
        boxSizing: "border-box"
    },
    lineNumber: {
        width: "60%",
        height: "39px",
        float: "left",
        fontSize: "30px",
        fontFamily: "Lato, sans-serif",
        boxSizing: "border-box",
        position: "relative",
        bottom: "6px",
        left: "5px"
    },
    arrow: {
        width: "40%",
        float: "left"
    }
}));